module.exports = __webpack_public_path__ + "img/img_term_tit.da504f95.svg";